<template>
  <DialogTemplate :show-controls="true" class="dialog" v-bind="props">
    <Heading align="center" tag="h4">
      {{ popupTitle }}
    </Heading>
    <p v-cleaned="htmlContent" />
    <div class="code-wrapper">
      <CodeInput v-model:code="code" :length="codeLength" size="small" />
      <FormErrorMessages :messages="feedback"></FormErrorMessages>
    </div>
    <ButtonBase
      :disabled="code.length !== codeLength && !submitting"
      stroke="n"
      theme="secondary"
      rounded
      class="button-submit"
      @click="handleClickSubmit"
    >
      {{ popupValidateButton }}
    </ButtonBase>
    <p v-if="error" class="error">{{ error.message }}</p>
  </DialogTemplate>
</template>
<script setup lang="ts">
import { Eva2Error, ErrorTypes } from '~/lib/errors/Eva2Error';
interface Props {
  closeTimer?: number;
  closeClickOutside?: boolean;
  position?: 'center' | 'top-right';
  title: string;
  description: string;
  codeLength: number;
  htmlContent: string;
  invalidCodeMessage: string;
  popupTitle: string;
  popupValidateButton: string;
  validCodeMessage: string;
}
const props = defineProps({
  closeTimer: null,
  closeClickOutside: { type: Boolean, default: true },
  position: { default: 'center' },
  title: null,
  description: null,
  codeLength: null,
  htmlContent: null,
  invalidCodeMessage: null,
  popupTitle: null,
  popupValidateButton: null,
  validCodeMessage: null
});

const emit = defineEmits(["valid"]);

const code = ref<string>('');
const submitting = ref<boolean>(false);
const error = ref<Eva2Error>(null);

const feedback = ref<string[]>([]);

const submit = async () => {
  const { error, status, result } = await useApiFetch(URI.ReferralVerify, {
    method: 'GET',
    params: {
      referralCode: code.value,
    },
  });
  let isValid = false;
  if (status >= 400) {
    throw new Eva2Error(ErrorTypes.Adam, {}, error.response._data.summary);
  }

  isValid = result.isValid;
  if (isValid) {
    emit('valid', code.value);
  } else {
    feedback.value = ['Ce code parrainage est invalide'];
  }
};

const handleClickSubmit = () => {
  submit();
};

watch(
  () => code.value,
  () => {
    error.value = null;
    feedback.value = [];
  }
);
</script>
<style lang="scss" scoped>
.button-submit {
  width: 100%;
}
.dialog {
  max-width: fit-content;
}
p {
  text-align: center;
}
.code-wrapper {
  position: relative;
  width: 100%;
  padding-top: 0.6rem;
  .messages {
    justify-content: center;
    background-color: var(--color_neutral_50);
    text-align: center;
  }
}
</style>
